/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export default {
  languageId: 'en-US',
  languageName: 'English',
  localizedLanguageName: 'English',
  contents: {
    Yes: 'Yes',
    No: 'No',
  },
};
